import ApplicationList from '../components/admin/ApplicationList';

const ApplicationsPage = () => {
  return <ApplicationList />;
};

export default ApplicationsPage;